import gql from 'graphql-tag';
import { convertFilterRequestUrl } from 'utils/utils';

export default ({ filter, page, size, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, [])}` : '';
  const searchConfigOperatorData = `searchConfigOperatorData(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${searchConfigOperatorData} {
        id
        operatorId
        chargeType
        index
        tierMin
        tierMax
        tariff
        contractCapacity
        commitmentBase
        rentalAmount
        exchangeRate
      }
    }
  `;
};
